const dispatchGenericEvent = (eventName = null, detail = null, el) => {
  if (eventName) {
    try {
      const event = new CustomEvent(eventName, { detail });
      const element = el ? el : document;

      element.dispatchEvent(event);
    } catch (error) {
      return;
    }
  } else {
    return;
  }
};

export { dispatchGenericEvent };
